import {HOMOYNM_BOX_MIN_PADDING, HOMONYM_BOX_PADDING, HOMONYM_BOX_MAX_PADDING_TOP} from '../defines/client.const';
import {IsEmptyString} from "../defines/common.func";
import {Word} from './word.model';

const HOMONYM_SMALL = 3;

export class Homonym {

  // 서버에서 보내주는 값
  name: string;
  listWord: Array<Word>;

  // 내부 처리용
  paddingLeft = 0;
  paddingTop = 0;
  offsetTop?: number; // 단어가 화면에 표시되는 위치 (단어가 화면에 표시되는 위치를 저장한다. 속도 향상을 위해서 저장.)


  constructor(obj?: any) {
    this.name           = (obj && obj.name)         ?? null;

    this.listWord       = new Array<Word>();
    if ('words' in obj) {
      obj.words.forEach(value => this.listWord.push(new Word(value)));
    }

    // console.log('Homonym()', obj, this);
  }

  /**
   * 이 동음이의어가 작은지 판단하는 함수.
   * HomonymBox의 Type1~4를 결정하는데 사용됨
   */
  public IsSmall(): boolean {
    return this.listWord.length < HOMONYM_SMALL;
  }

  public get hasVoice(): boolean {
    return this.listWord.some(word => !IsEmptyString(word.wordVoice));
  }
}

